import React from 'react';
import { DashboardLayout } from "./Dashboard";
import { useParams, useLocation } from "react-router";
import { useGetData } from "@/hooks/useGetData";
import LoaderWrapper from "./LoaderWrapper";
import PulseOximeterAlertView from "./alertViews/PulseOximeterAlertView";
import GlucoseMeterAlertView from "./alertViews/GlucoseMeterAlertView";
import BloodPressureAlertView from "./alertViews/BloodPressureAlertView";

const PandingAlertView = () => {
  const { alertId } = useParams();
  const location = useLocation();
  const alertHistoryRow = (location.state as { alertHistoryRow?: { reading?: string; device?: string; timestamp?: string } } | null)?.alertHistoryRow;

  const { apiData: response, loading, err } = useGetData(
    `/triage-forms/alert/${alertId}`,
    {},
    false,
    true,
  );

  const renderDeviceView = () => {
    if (!response?.success || !response?.data?.forms?.[0]) {
      return null;
    }

    const deviceType = response.data.forms[0].deviceType;

    switch (deviceType) {
      case 'pulse_oximeter':
        return <PulseOximeterAlertView data={response} listRow={alertHistoryRow} />;
      case 'glucose_meter':
        return <GlucoseMeterAlertView data={response} listRow={alertHistoryRow} />;
      default:
        return <BloodPressureAlertView data={response} listRow={alertHistoryRow} />;
    }
  };

  return (
    <DashboardLayout activePage="/alerts">
      <LoaderWrapper loading={loading} error={err}>
        {renderDeviceView() || (
          !loading && (
            <div className="bg-gray-100 min-h-screen py-8 px-4">
              <div className="bg-white shadow-lg max-w-2xl mx-auto p-8 rounded-lg">
                <div className="text-center py-10">
                  <p className="text-gray-500">
                    No form data available for this alert.
                  </p>
                </div>
              </div>
            </div>
          )
        )}
      </LoaderWrapper>
    </DashboardLayout>
  );
};

export default PandingAlertView